import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { keyBy, keys, omit, values } from 'lodash';
import { FontIcon } from 'office-ui-fabric-react';
import dropdownStyle, { styles } from './MultiPicker.style';

const MultiPicker = ({ options, multiTag, placeholder, selected, onChange, ...others }) => {
  const itemMap = keyBy(selected, 'key');
  const onDropdownChange = (_, option) => {
    if (!option.selected) {
      onChange(values(omit(itemMap, option.key)));
    } else if (selected) {
      onChange([...selected, omit(option, 'selected')]);
    } else {
      onChange([omit(option, 'selected')]);
    }
  };

  const renderTitleAsTag = dropDownOptions => {
    return (
      <div>
        {dropDownOptions.map(opt => {
          return (
            <span key={opt.key} className={styles.tagOption}>
              <FontIcon
                iconName="Clear"
                ariaLabel="Clear"
                className={styles.iconClear}
                onClick={e => onDropdownChange(e, { selected: false, key: opt.key })}
              />
              {` ${opt.text}`}
            </span>
          );
        })}
      </div>
    );
  };

  const onRenderTitleOptions = multiTag ? { onRenderTitle: renderTitleAsTag } : {};

  return (
    <>
      <Dropdown
        multiSelect
        placeholder={placeholder}
        options={options}
        ariaLabel={placeholder || 'multi select'}
        selectedKeys={keys(itemMap)}
        onChange={onDropdownChange}
        styles={dropdownStyle}
        {...others}
        {...onRenderTitleOptions}
      />
    </>
  );
};

MultiPicker.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  selected: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
  multiTag: PropTypes.bool,
  placeholder: PropTypes.string,
};

MultiPicker.defaultProps = {
  onChange: () => {},
  selected: undefined,
  multiTag: false,
  placeholder: 'Select',
};

export default MultiPicker;
